import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.split.js';
import * as Yup from 'yup';
import { DocumentType } from '../../domain/enums/bank-account.js';
import { Document } from '../../domain/vos/document.js';
import { Email } from '../../domain/vos/email.js';
import { Phone } from '../../domain/vos/phone.js';

const personSchema = Yup.object().shape({
  businessOwner: Yup.object().shape({
    documentType: Yup.number().required('errors.required').oneOf([DocumentType.CNPJ, DocumentType.CPF], 'errors.invalidModality'),
    documentNumber: Yup.string().required('errors.required').test({
      message: 'errors.invalidCpf',
      test: function (value) {
        return Document.build(String(value)).isValidCPF() || Document.build(String(value)).isValidCNPJ();
      }
    }),
    fullName: Yup.string().required('errors.required').test({
      name: 'fullName',
      message: 'errors.invalidFullName',
      test: function (value) {
        // At least two words, none of them empty.
        return String(value).split(' ').filter(x => x !== '').length >= 2;
      }
    }),
    email: Yup.string().email('errors.invalidEmail').required('errors.required').test({
      message: 'errors.invalidEmail',
      test: function (value) {
        return Email.build(String(value)).isValid();
      }
    }),
    phoneNumber: Yup.string().required('errors.required').test({
      message: 'errors.invalidPhoneNumber',
      test: function (value) {
        return Phone.build(String(value)).isValid();
      }
    })
  })
});

export { personSchema };
